/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '@mottu-ops/global-components';
import { TranslateService } from '@mottu-ops/locale';
import { TotemAccess } from '@domain/models';
import { KeycloakService } from '@mottu-ops/keycloak-angular';

@Injectable({
	providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
	mottuTotemAccesskey = 'mottu-totem.access';
	userAgentName = 'attendance-totem';

	constructor(
		private notify: NotificationService,
		private translateService: TranslateService,
		private keycloakService: KeycloakService
	) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let header = req.headers.set('language', this.headerLanguage).set('attendance-user-agent', this.userAgentName);

		if (this.getBranchCode) header = header.set('branch-id', this.getBranchCode);

		if (this.keycloakService.isLoggedIn()) {
			const token = this.keycloakService.getKeycloakInstance().token;
			if (token) header = header.set('Authorization', 'Bearer ' + token);
		}

		const newReq = req.clone({
			headers: header,
		});

		return next.handle(newReq).pipe(catchError(error => this.errorHandler(error)));
	}

	private errorHandler(response: HttpErrorResponse): Observable<HttpEvent<any>> {
		switch (response.status) {
			case 0:
				this.notify.showNotification(
					'error',
					this.translateService.getInstantTranslation('CORE-INTERCEPTOR.SERVER-CONNECTION')
				);
				break;
			case 401:
				this.notify.showNotification(
					'error',
					this.translateService.getInstantTranslation('CORE-INTERCEPTOR.UNAUTHORIZED')
				);
				break;
			case 404:
				this.notify.showNotification(
					'error',
					this.translateService.getInstantTranslation('CORE-INTERCEPTOR.NOT-FOUND')
				);
				break;
			case 406:
			case 409:
			case 500:
			case 503:
				this.notify.showNotification(
					'error',
					this.translateService.getInstantTranslation('CORE-INTERCEPTOR.SERVER-ERROR')
				);
				break;
		}

		return throwError(() => response);
	}

	private get headerLanguage(): string {
		const lang = localStorage.getItem('lang');
		switch (lang) {
			case 'es':
				return 'es-MX';
			default:
				return 'pt-BR';
		}
	}

	private get getBranchCode(): string | null {
		const totemAccessValue = localStorage.getItem(this.mottuTotemAccesskey);
		if (!totemAccessValue) return null;

		const totemAccess: TotemAccess = JSON.parse(totemAccessValue);
		return totemAccess.branchCode.toString();
	}
}
